import { isNumber } from "lodash"

export const isOperatingTimeValid = (min: number | undefined | null, max: number | undefined | null) => {
  if (!isNumber(min) || !isNumber(max)) return false
  if (min < 0 || min > 24) return false
  if (max < 0 || max > 24) return false

  return min < max
}